import type { FlowCardDefinition } from '../types';

export const setVariableCard: FlowCardDefinition = {
	type: 'setVariable',
	version: '1.0.0',
	domain: 'core',
	role: 'action',
	category: 'specialCards',
	label: 'Set Variable',
	description: 'Assign a value to a named Flow variable',
	icon: 'fa-equals',
	color: '#f97316',
	schema: {
		$schema: 'https://json-schema.org/draft/2020-12/schema',
		type: 'object',
		required: ['variable'],
		properties: {
			variable: {
				type: 'object',
				required: ['name'],
				properties: {
					name: { type: 'string', title: 'Name', minLength: 1 },
					value: { type: 'string', title: 'Value', default: '' },
				},
			},
		},
	},
	fields: [
		{ path: 'variable.name', label: 'Variable name', type: 'text', placeholder: 'e.g. mode' },
		{ path: 'variable.value', label: 'Value', type: 'text', placeholder: 'e.g. away' },
	],
	ports: { sources: ['output'] },
	defaults: () => ({ variable: { name: '', value: '' }, cardVersion: '1.0.0' }),
	summary: (data) =>
		data.variable?.name
			? `Set ${data.variable.name} to ${String(data.variable.value ?? '')}`
			: 'Choose a variable and value',
	validate: (data) =>
		String(data.variable?.name || '').trim()
			? []
			: [{ path: 'variable.name', message: 'Variable name required' }],
	compile: (node) => {
		if (node.data.sceneData) return { ...node.data.sceneData, _fid: node.id };
		if (node.data.originalAction) return { ...node.data.originalAction, _fid: node.id };
		return {
			_gui_type: 'set_variable',
			_gui_purpose: 'action',
			name: String(node.data.variable?.name || ''),
			value: node.data.variable?.value ?? '',
			_flow_card: 'setVariable',
			_flow_card_version: '1.0.0',
		};
	},
};
